import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { brandLayout } from '../../styled/brand'

/**
 * The `.wrap` container from the design: a centered column, max-width 1320px,
 * with generous horizontal padding that tightens on mobile. Every section's
 * content sits inside one of these.
 */
export const Wrap = styled(Box)(({ theme }) => ({
  maxWidth: brandLayout.maxWidth,
  margin: '0 auto',
  paddingLeft: brandLayout.padX,
  paddingRight: brandLayout.padX,
  position: 'relative',
  [theme.breakpoints.down('md')]: {
    paddingLeft: brandLayout.padXMobile,
    paddingRight: brandLayout.padXMobile,
  },
}))
